import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  private buildTime: string;
  private buildTimeDate: Date;
  private buildVersion: string;

  constructor() {
    // -------------------------------------------------------------------
    // DO NOT update manually. This is updated by the installation script.
    this.buildTime = '2026-10-23T20:46:40Z';
    // -------------------------------------------------------------------

    this.buildTimeDate = new Date(this.buildTime);
    this.buildVersion = this.formatDateAsVersion(this.buildTimeDate);
  }

  getBuildTime() : Date {
    return this.buildTimeDate;
  }

  getBuildVersion() : string {
    return this.buildVersion;
  }

  private formatDateAsVersion(date: Date) : string {
    return date.getFullYear().toString()
        + '.'
        + (date.getMonth() + 1).toString().padStart(2, '0')
        + '.'
        + date.getDate().toString().padStart(2, '0')
        + ' '
        + date.getHours().toString().padStart(2, '0')
        + '.'
        + date.getMinutes().toString().padStart(2, '0');
  }

}
